import React, { useState } from 'react';
import { Modal, Textarea } from '@mantine/core';
import { Button } from '../../../../components/Button';
import { assistantService } from '../../../../services/assistant/assistant.service';
import { toHebrewApiErrorMessage } from '../../../../services/index/index.service';
import classes from './assistant-panel.module.scss';

type Message = { role: 'user' | 'assistant'; content: string };

const SUGGESTIONS = [
  'איזה עובדים נתנו בראש השבוע?',
  'מה המנות הכי חזקות השבוע?',
  'כמה נמכר היום לעומת אתמול?',
  'כמה ביטולים היו הערב ומי ביצע אותם?',
  'כמה טיפ גבינו הערב?',
];

export const AssistantPanel: React.FC<{ tenantId: string; opened: boolean; onClose: () => void }> = ({ tenantId, opened, onClose }) => {
  const [question, setQuestion] = useState('');
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(false);

  const ask = async (nextQuestion = question) => {
    const trimmed = nextQuestion.trim();
    if (!trimmed || loading) return;
    setQuestion('');
    setMessages((current) => [...current, { role: 'user', content: trimmed }]);
    setLoading(true);
    try {
      const answer = await assistantService.ask(tenantId, trimmed);
      setMessages((current) => [...current, { role: 'assistant', content: answer }]);
    } catch (error: unknown) {
      const message = error instanceof Error ? toHebrewApiErrorMessage(error.message) : 'אירעה שגיאה. נסו שוב.';
      setMessages((current) => [...current, { role: 'assistant', content: message }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="עוזר עסקי" size="lg" centered dir="rtl">
      <div className={classes.panel}>
        {messages.length === 0 ? <div className={classes.suggestions}>{SUGGESTIONS.map((suggestion) => (
          <Button key={suggestion} variant="cancel" size="sm" onClick={() => void ask(suggestion)}>{suggestion}</Button>
        ))}</div> : null}
        <div className={classes.messages} aria-live="polite">
          {messages.map((message, index) => <div key={`${message.role}-${index}`} className={message.role === 'user' ? classes.userMessage : classes.assistantMessage}>{message.content}</div>)}
          {loading ? <div className={classes.assistantMessage}>בודק את הנתונים...</div> : null}
        </div>
        <div className={classes.composer}>
          <Textarea value={question} onChange={(event) => setQuestion(event.currentTarget.value)} placeholder="שאל שאלה על העסק" autosize minRows={2} maxRows={4} />
          <Button variant="confirm" loading={loading} loadingLabel="בודק" onClick={() => void ask()}>שלח</Button>
        </div>
      </div>
    </Modal>
  );
};